<template>
  <div class="bot-config">
    <form @submit.prevent="updateBot" class="forms-sample">
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Bot Name:</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" v-model="botData.appName" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Description:</label>
        <div class="col-sm-8">
          <textarea class="form-control" v-model="botData.description" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Status:</label>
        <div class="col-sm-8">
          <select class="form-control" v-model="botData.status" style="
              background-color: #2b2e4c;
              color: #e9e6e6;
              border: 1px solid #424351;
            ">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-8 offset-sm-4">
          <button type="submit" class="btn btn-primary text-white">Update Settings</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import botApi from "@/shared/botApi";

export default {
  name: 'BotConfig',
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      botData: {
        appId: "",
        appName: "",
        description: "",
        botType: "",
        status: "active"
      }
    };
  },
  methods: {
    getBotData() {
      const botId = this.$route.params.id;
      botApi
        .getWhatsappBotById(botId)
        .then((response) => {
          if (response.status === "00") {
            this.botData = response.data;
          } else {
            this.toast.error(response.message || "Failed to fetch bot settings");
          }
        })
        .catch((error) => {
          this.toast.error(error.message || "Failed to fetch bot settings");
        });
    },
    updateBot() {
      botApi
        .updateWhatsappBot(this.botData)
        .then((response) => {
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getBotData();
          } else {
            this.toast.error(response.message);
          }
        })
        .catch((error) => {
          this.toast.error(error.message);
        });
    }
  },
  mounted() {
    this.getBotData();
  }
};
</script>

<style scoped>
.bot-config {
  background-color: #2b2e4c;
  padding: 20px;
  border-radius: 4px;
}

.form-control {
  background-color: #2b2e4c;
  color: #e9e6e6;
  border: 1px solid #424351;
}

.form-control:focus {
  background-color: #2b2e4c;
  color: #e9e6e6;
  border-color: #4B49AC;
  box-shadow: none;
}

.col-form-label {
  color: #e9e6e6;
}

.btn-primary {
  background-color: #4B49AC;
  border-color: #4B49AC;
}

.btn-primary:hover {
  background-color: #3f3d8f;
  border-color: #3f3d8f;
}
</style> 